<h1 mat-dialog-title>
  {{title | translate}}
</h1>
<div mat-dialog-content>
  <p [innerHtml]="message"></p>
  <div>
    <app-form-field #fileFormField type="FILE"
                    label="File"
                    [settings]="settings.fieldsSettings.file"
                    [value]="valuesForInput.file"
                    (modelChange)="updateCurrentValue('file',$event)"
                    (enter)="logEnterPressed()"
                    width="400px">
    </app-form-field>

    <mat-progress-bar style="margin: 20px 0 10px 0; " *ngIf="upload"
      [mode]="upload.state == 'PENDING' ? 'buffer' : 'determinate'" 
      [value]="upload.progress">
    </mat-progress-bar>

    <app-json-viewer *ngIf="outcome" [datasource]="outcome"></app-json-viewer>
  </div>
</div>
<div mat-dialog-actions>
  <div class="layout horizontal space-between" style="width: 100%;">
    <app-button [label]="'CANCEL'|translate" icon="arrow-left" [disabled]="formSubmitting" [mat-dialog-close]="null"></app-button>
    <div>
      <app-button [label]="'FILE_IMPORT_DIALOG.ANALYZE'|translate" icon="file-check" [disabled]="!this.currentValues.file || formSubmitting"
                  (click)="analyze()"></app-button>
      <app-button [label]="'FILE_IMPORT_DIALOG.IMPORT'|translate" primary="true" icon="file-upload" [disabled]="!this.currentValues.file || formSubmitting"
                  marginBefore='4px'
                  (click)="import()"></app-button>
    </div>
  </div>
</div>